import { buildImgSrcSet } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import { LazyImage } from '@sunwebgroup/uds-ui/lazy-image'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './ExcursionCard.module.css'

export interface ExcursionCardProps {
  title: string
  description?: string
  mediaSrc?: string
  price?: number
  showPriceIfEmpty?: boolean
}

const DEFAULT_EXCURSION_CURRENCY = 'EUR'

export function ExcursionCard({ title, description, mediaSrc, price, showPriceIfEmpty }: ExcursionCardProps) {
  const intl = useIntl()
  return (
    <div className={styles.card}>
      {mediaSrc && (
        <div className={styles.imageWrapper}>
          <LazyImage
            placeholderSrc={mediaSrc}
            src={mediaSrc}
            srcSet={buildImgSrcSet(mediaSrc, [480])}
            alt={title || ''}
            loading="lazy"
            aspectRatio="16:9"
          />
        </div>
      )}
      <div className={styles.content}>
        {title && (
          <div className={styles.header}>
            <Typography variant="display-g-regular" as="h3">
              {title}
            </Typography>
            {(showPriceIfEmpty || price) && (
              <Typography variant="display-h-regular" as="p">
                {intl.formatMessage(
                  { id: 'destination_excursions_from_label' },
                  { price: intl.formatTruncatedCurrency(price ?? 0, { currency: DEFAULT_EXCURSION_CURRENCY }) },
                )}
              </Typography>
            )}
          </div>
        )}
        {description && (
          <Typography variant="body-s-regular-tight" as="p">
            {description}
          </Typography>
        )}
      </div>
    </div>
  )
}
